import type { AnalyticsEvent, AnalyticsEventPageProperties } from "@octopusdeploy/portal-analytics";
import type { UnknownPageRegistration } from "~/routing/pageRegistrations/PageRegistration";
import type { Workflow } from "~/workflows/workflows";

interface WorkflowAbortedEvent extends AnalyticsEvent<"Workflow Aborted">, Partial<AnalyticsEventPageProperties> {
    WorkflowId: string;
    WorkflowInstanceId: string;
    WorkflowType: "drawer" | "dialog";
    ["Duration (ms)"]: number;
}

interface WorkflowAbortedEventArguments {
    workflow: Workflow<unknown, unknown>;
    workflowInstanceId: string;
    pageRegistration: UnknownPageRegistration | null;
    durationInMs: number;
}

export function createWorkflowAbortedEvent({ workflow, workflowInstanceId, pageRegistration, durationInMs }: WorkflowAbortedEventArguments): WorkflowAbortedEvent {
    const pageFields: AnalyticsEventPageProperties | undefined =
        pageRegistration === null
            ? undefined
            : {
                  "Page Id": pageRegistration.pageId,
                  "Page Area": pageRegistration.pageArea.mainArea,
              };
    return {
        eventName: "Workflow Aborted",
        WorkflowId: workflow.workflowId,
        WorkflowType: workflow.workflowType,
        WorkflowInstanceId: workflowInstanceId,
        "Duration (ms)": durationInMs,
        ...pageFields,
    };
}
